import styled from 'styled-components';
import { motion } from 'framer-motion';

const SAbout = styled(motion.div)`
  ${(props) => props.theme.layout.wrapperMobile};
  ${(props) => props.theme.layout.routeMotion};
  min-height: 100vh;
  background: ${(props) => props.theme.color.gradient.accent};
  color: white;
  @media screen and (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    ${(props) => props.theme.layout.wrapper};
    position: absolute;
  }
`;

const SHeader = styled.header`
  ${(props) => props.theme.layout.header};

  text-align: center;
  &::after {
    content: '';
    background: white;
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints.phablet}) {
    padding: 0px 10% 1.5em;
    p {
      font-size: ${(props) => props.theme.font.size.medium};
    }
  }
`;

const SPageTitle = styled.h1`
  font-size: ${(props) => props.theme.font.size.h2};
  line-height: 1.3;
  margin-bottom: ${(props) => props.theme.spacing.rem(4)};
  @media screen and (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    font-size: ${(props) => props.theme.font.size.h1};
  }
`;

const SSection = styled.section`
  text-align: center;
  margin-bottom: ${(props) => props.theme.spacing.rem(8)};
  @media screen and (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    width: 47%;
    text-align: left;
  }
`;

const SMain = styled.main`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  text-align: left;
`;

const SMainTitle = styled.h2`
  margin-bottom: ${(props) => props.theme.spacing.rem(2)};
`;

const SMainContent = styled.div``;

export {
  SAbout,
  SSection,
  SHeader,
  SMain,
  SMainTitle,
  SMainContent,
  SPageTitle,
};
